module.exports = __webpack_public_path__ + "img/1.76b11263.png";